// Cache a parsed version of the query parameters.
// This doesn't allow for live updates.
const params = new URLSearchParams(window.location.search);

// Get a single value, with a fallback.
export default function Get(name, fallback) {
	const value = params.get(name);
	return value !== null ? value : fallback;
}
